import { apiClient } from './api-client';

export interface SavedFilter {
  id: string;
  tenantId: string;
  name: string;
  description?: string;
  filters: Record<string, any>;
  visibility: 'private' | 'public';
  isDefault: boolean;
  createdBy: string;
  usageCount: number;
  lastUsedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSavedFilterDto {
  name: string;
  description?: string;
  filters: Record<string, any>;
  visibility?: 'private' | 'public';
  isDefault?: boolean;
}

export interface UpdateSavedFilterDto {
  name?: string;
  description?: string;
  filters?: Record<string, any>;
  visibility?: 'private' | 'public';
  isDefault?: boolean;
}

class SavedFiltersService {
  private readonly basePath = '/tickets/saved-filters';

  async getAll(): Promise<SavedFilter[]> {
    const response = await apiClient.get<SavedFilter[]>(this.basePath);
    return response.data;
  }

  async create(dto: CreateSavedFilterDto): Promise<SavedFilter> {
    const response = await apiClient.post<SavedFilter>(this.basePath, dto);
    return response.data;
  }

  async update(id: string, dto: UpdateSavedFilterDto): Promise<SavedFilter> {
    const response = await apiClient.put<SavedFilter>(`${this.basePath}/${id}`, dto);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${this.basePath}/${id}`);
  }

  async setDefault(id: string): Promise<SavedFilter> {
    const response = await apiClient.patch<SavedFilter>(`${this.basePath}/${id}/default`);
    return response.data;
  }

  async trackUsage(id: string): Promise<void> {
    await apiClient.patch(`${this.basePath}/${id}/usage`);
  }
}

export const savedFiltersService = new SavedFiltersService();
